export class Dailyverses {
    IdDayVerse: number;
    URL: string;
    Enabled: boolean;
    ScheduleDate: Date;
    IsDefault: boolean;
}